// Connections dialog component for the library page

import React from 'react';
import ConnectionsContent from '../account/ConnectionsContent';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';

const ConnectionsDialog: React.FC<LibraryDialogOutletProps> = ({
  user,
  dialog,
  connectionsTwitchError,
  setDialog,
}) => {
  if (!user) {
    return null;
  }

  return (
    <Dialog
      open={dialog === 'connections'}
      onOpenChange={(nextOpen) => setDialog(nextOpen ? 'connections' : null)}
    >
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Connections</DialogTitle>
          <DialogDescription>
            Manage connected accounts used for identity, moderation, and other
            features.
          </DialogDescription>
        </DialogHeader>
        <ConnectionsContent
          user={user}
          connectionsTwitchError={connectionsTwitchError}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ConnectionsDialog;
